

export default {
    name: "DatatableComponent",
    components: {
    },
    props: {
        chartData: {
            type: Array,
        },
        title: {
            type: String,
            default: () => {
                return ""
            }
        }
    },
    data() {
        return {
            headers: [],
            dataset: []
        };
    },
    mounted() {

        if (this.chartData && this.chartData.length > 0) {
            this.headers = Object.keys(this.chartData[0]).map(x => { return { text: x, value: x } })
            this.dataset = this.chartData
        }

    },
    methods: {

    }
};
